import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";
import Calendar from "@fullcalendar/react";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";
import Loader from "../../../core/common/selfLoder";
import { getFinancialYearList } from "../../../core/common/financialYear";

const LeaveApplication = () => {
  const navigate = useNavigate();
  const Location = useLocation();
  const calendarRef = useRef<Calendar | null>(null);
  const [leaveTypeName, setLeaveTypeName] = useState("");
  const [medcerInputbox, setMedcerInputbox] = useState(false);

 const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear(); 
    return formatFinancialYear(year);
  };

  const [finance_year, setFinance_year] = useState(getFinancialYear());


  const {
    data: leavetype,
    loading: leavetype_loading,
    error: leavetype_error,
  } = useApi("/api/master/get-leave-type", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: leave_slice_type,
    loading: leave_slice_type_loading,
    error: leave_slice_type_error,
  } = useApi("/api/master/get-leave-slice-type", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: manager_email,
    loading: manager_email_loading,
    error: manager_email_error,
  } = useApi("/api/manager-email", {
    method: "GET",
    autoCall: true,
  });

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };

  useEffect(() => {
    const handleShown = () => {
      if (calendarRef.current) {
        requestAnimationFrame(() => {
          const calendarApi = calendarRef.current!.getApi();
          calendarApi.updateSize();
        });
      }
    };

    const modalElement = document.getElementById("exampleModalLg");
    if (modalElement) {
      modalElement.addEventListener("shown.bs.modal", handleShown);
    }

    return () => {
      if (modalElement) {
        modalElement.removeEventListener("shown.bs.modal", handleShown);
      }
    };
  }, []);

  useEffect(() => {
    if (manager_email?.data?.manager_email_id) {
      setData((prev) => ({
        ...prev,
        manager_email: manager_email.data.manager_email_id,
      }));
    }
  }, [manager_email]);

  const [data, setData] = useState({
    apply_date: new Date().toISOString().split("T")[0],
    leave_type_id: "",
    from_date: "",
    to_date: "",
    leave_slice_id: "",
    reason: "",
    manager_email: manager_email,
    cc_email: "",
    is_medical_cert_exist: "0",
    medical_docs: null as File | null,
  });


  const getInputData = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    if (name === "leave_slice_id") {
      setData((prev) => ({
        ...prev,
        [name]: value,
        to_date: prev.to_date ? "" : prev.to_date,
      }));
    }
    if (name === "is_medical_cert_exist") {
      value === "1" ? setMedcerInputbox(true) : setMedcerInputbox(false);
    }
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData({
      ...data,
      medical_docs: e.target.files ? e.target.files[0] : null,
    });
  };

  const {
    data: submitResponse,
    loading: submitLoading,
    error: submitError,
    callApi: submitLeaveRequest,
  } = useApi("/api/add-leave-application", {
    method: "POST",
    autoCall: false,
  });

  const postData = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });
    try {
      const response = await submitLeaveRequest(formData, undefined);
      if ((response.statusCode = 201)) {
        Swal.fire({
          title: "Success!",
          text: "Leave application submitted successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/leave-details");
      }
    } catch (error: any) {
      console.error("Submission failed:", error);
      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Failed to submit leave application. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: leavebalanceData,
    loading: leavebalanceLoading,
    error: leavebalanceError,
    callApi: getLeaveBalanceData,
  } = useApi("/api/view-leave-type-balance", {
    method: "POST",
    autoCall: false,
  });

  const getleaveData = async (leaveTypeID: any) => {
    const payload = {
      leave_type_id: leaveTypeID,
      financial_year: finance_year
    };
    try {
      const response = await getLeaveBalanceData(payload)
      console.log(response)
    } catch (error) {
      console.log(error)
    }
  };

  return (
    <>
      <Loader
        loading={
          leavetype_loading ||
          leave_slice_type_loading ||
          manager_email_loading ||
          manager_email_loading
          // submitLoading
        }
      />
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-2">
            <div className="my-auto mb-2">
              <h2 className="mb-2">Leave Application</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">Leave</li>
                  <li className="breadcrumb-item">
                    <Link to={all_routes.seflGrid}>Self Leave</Link>
                  </li>

                  <li className="breadcrumb-item active" aria-current="page">
                    Leave Application
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div>
                <Link
                  to="/self-leave-dashboard"
                  className="btn btn-primary custom_button py-1 px-3"
                >
                  Leave Dashboard
                </Link>
              </div>
              <div className="me-2 mb-2"></div>
              {/* <div className="input-icon w-120 position-relative mb-2">
                <span className="input-icon-addon">
                  <i className="ti ti-calendar text-gray-9" />
                </span>
              <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {getFinancialYearList().map((fy) => (
                    <option key={fy} value={fy}>
                      {fy.split("-")[0]}
                    </option>
                  ))}
                </select>

              </div> */}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-9">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={postData}>
                    {/* Application Plan */}
                    <div className="d-flex gap-2 justify-content-center align-items-center">
                      <h4
                        className="mb-4 rounded"
                        style={{
                          textDecoration: "underline",
                          fontSize: "1.5rem", // slightly bigger than default h4
                          fontWeight: "600", // semi-bold
                          color: "#333", // dark shade for better readability
                        }}
                      >
                        Application
                      </h4>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">
                          <strong>Apply Date</strong>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="apply_date"
                          value={dayjs().format("D MMMM YYYY")}
                          readOnly
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">
                          <strong>
                            Leave Type<sup className="text-danger">*</sup>
                          </strong>
                        </label>
                        <select
                          className="form-select"
                          required
                          name="leave_type_id"
                          onChange={(e) => {
                            const selectedId = Number(e.target.value);
                            const selectedItem = leavetype?.data?.find(
                              (item: any) => item.leave_type_id === selectedId
                            );
                            if (selectedItem) {
                              setLeaveTypeName(selectedItem.leave_type);
                              getleaveData(selectedItem.leave_type_id);
                            }
                            getInputData(e);
                          }}
                        >
                          <option value="" selected disabled>Select Leave Type</option>
                          {leavetype?.data?.map((item: any, index: number) => (
                            <option value={item?.leave_type_id}>
                              {item?.leave_type}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        <strong>Leave Slice</strong>
                      </label>
                      <div className="d-flex gap-4 flex-wrap">
                        {leave_slice_type?.data.map(
                          (item: any, index: number) => (
                            <div className="form-check" key={index}>
                              <input
                                className="form-check-input"
                                type="radio"
                                name="leave_slice_id"
                                id={`half${index}`}
                                value={item?.leave_slice_id}
                                onChange={getInputData}
                                required
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`half${index}`}
                              >
                                {item?.slice_type}
                              </label>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">
                          <strong>
                            Date From<sup className="text-danger">*</sup>
                          </strong>
                        </label>
                        <div className="input-icon-end position-relative">
                          <DatePicker
                            className="form-control datetimepicker"
                            format={{ format: "DD-MM-YYYY", type: "mask" }}
                            getPopupContainer={getModalContainer}
                            placeholder="DD-MM-YYYY"
                            name="from_date"
                            required
                            value={
                              data.from_date
                                ? dayjs(data.from_date, "YYYY-MM-DD")
                                : null
                            }
                            onChange={(date) => {
                              const newFromDate = date
                                ? date.format("YYYY-MM-DD")
                                : "";

                              setData((prev) => {
                                const currentToDate = dayjs(
                                  prev.to_date,
                                  "YYYY-MM-DD"
                                );

                                // Clear `to_date` if it's before the newly selected `from_date`
                                const shouldClearToDate =
                                  prev.to_date &&
                                  date &&
                                  currentToDate.isBefore(date, "day");

                                return {
                                  ...prev,
                                  from_date: newFromDate,
                                  to_date: shouldClearToDate
                                    ? ""
                                    : prev.to_date,
                                };
                              });
                            }}
                          />
                          <span className="input-icon-addon">
                            <i className="ti ti-calendar text-gray-7" />
                          </span>
                        </div>
                      </div>

                      {data.leave_slice_id === "1" ? (
                        <div className="col-md-6">
                          <label className="form-label">
                            <strong>
                              Date To<sup className="text-danger">*</sup>
                            </strong>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker"
                              format={{ format: "DD-MM-YYYY", type: "mask" }}
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              name="to_date"
                              required
                              value={
                                data.to_date
                                  ? dayjs(data.to_date, "YYYY-MM-DD")
                                  : null
                              }
                              onChange={(date) =>
                                setData((prev) => ({
                                  ...prev,
                                  to_date: date
                                    ? date.format("YYYY-MM-DD")
                                    : "",
                                }))
                              }
                              disabledDate={(current: any) => {
                                const fromDate = dayjs(
                                  data.from_date,
                                  "YYYY-MM-DD"
                                );
                                return current && current.isBefore(fromDate, "day");
                              }}
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        <strong>
                          Reason<sup className="text-danger">*</sup>
                        </strong>
                      </label>
                      <textarea
                        className="form-control"
                        rows={3}
                        required
                        placeholder="Enter reason for leave"
                        name="reason"
                        onChange={getInputData}
                      ></textarea>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">
                          <strong>
                            Manager Email<sup className="text-danger">*</sup>
                          </strong>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          defaultValue={data.manager_email}
                          required
                          name="manager_email"
                          readOnly
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">
                          <strong>CC Mail (Optional)</strong>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter CC email"
                          name="cc_email"
                          onChange={getInputData}
                        />
                      </div>
                    </div>

                    {/* Medical Certificate */}
                    {leaveTypeName === "Sick Leave" ||
                      leaveTypeName === "Maternity Leave" ||
                      leaveTypeName === "Bereavement Leave" ||
                      leaveTypeName === "Wedding Leave" ? (
                      <div className="mb-3">
                        <label className="form-label">
                          <strong>Documents</strong>
                        </label>
                        <div className="d-flex gap-4">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="is_medical_cert_exist"
                              id="certYes"
                              value="1"
                              onChange={getInputData}
                              required
                            />
                            <label
                              className="form-check-label"
                              htmlFor="certYes"
                            >
                              Yes
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="is_medical_cert_exist"
                              id="certNo"
                              value="0"
                              onChange={getInputData}
                              required
                            />
                            <label
                              className="form-check-label"
                              htmlFor="certNo"
                            >
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {/* Conditionally render the file input if "Yes" is selected */}
                    {medcerInputbox && (
                      <div className="mb-3">
                        <label className="form-label">
                          <strong>Upload Documents</strong>
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          name="medical_docs"
                          onChange={handleFileChange}
                          required
                        />
                      </div>
                    )}

                    {/* Submit Button */}
                    <div className="d-flex justify-content-center mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary custom_button btn-lg"
                      >
                        Apply Leave
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {
              leaveTypeName === "" ||  leaveTypeName !=="" ? <div className="col-md-3">
                <div
                  className="stickybar"
                  style={{ position: "sticky", top: "60px", zIndex: 100 }}
                >
                  <div className="card">
                    <div className="card-body p-3">
                      <table className="table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th colSpan={2} className="text-center bg-light">
                              Selected Leave Detail
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th>Total Balance</th>
                            <td>
                              {(
                                (parseFloat(
                                  leavebalanceData?.data?.opening_balance
                                ) || 0) +
                                (parseFloat(
                                  leavebalanceData?.data?.prorata_balance
                                ) || 0)
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <th>Availed till Date</th>
                            <td>
                              {leavebalanceData?.data?.availed_balance || 0}
                            </td>
                          </tr>
                          <tr>
                            <th>Current Balance</th>
                            <td>{leavebalanceData?.data?.closing_balance || 0}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div> : (
                // <div className="col-md-3">
                //   <div
                //     className="stickybar"
                //     style={{ position: "sticky", top: "60px", zIndex: 100 }}
                //   >
                //     <div className="card ">
                //       <div className="card-body text-center p-4">
                //         <i
                //           className="ti ti-alert-circle text-warning mb-2"
                //           style={{ fontSize: "24px" }}
                //         ></i>
                //         <h6 className="fw-bold mb-1">No Leave Balance</h6>
                //         <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                //           No balance is maintained for this leave type as per company policy.
                //         </p>
                //       </div>
                //     </div>
                //   </div>
                // </div>
                ""
              )
            }
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModalLg"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Attendance Calendar
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <FullCalendar
                ref={calendarRef}
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                headerToolbar={{
                  start: "",
                  center: "title",
                  end: "prev,next",
                }}
                height={500}
              />
              <div className="py-3">
                <div className="card">
                  <div className="card-body">
                    {/* <h6 className="mb-2">
                      <strong>Attendance Legend</strong>
                    </h6> */}
                    <div className="row">
                      <div className="col-md-6">
                        <ul className="list-unstyled mb-2">
                          <li>
                            <strong
                              style={{
                                display: "inline-block",
                                width: "16px",
                                height: "16px",
                                backgroundColor: "#00D3CF", // Weekly Off
                                marginRight: "8px",
                              }}
                            ></strong>
                            Weekly Off
                          </li>
                          <li>
                            <strong
                              style={{
                                display: "inline-block",
                                width: "16px",
                                height: "16px",
                                backgroundColor: "#FF0000", // Absent
                                marginRight: "8px",
                              }}
                            ></strong>
                            Absent
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="list-unstyled mb-2">
                          <li>
                            <strong
                              style={{
                                display: "inline-block",
                                width: "16px",
                                height: "16px",
                                backgroundColor: "#000000", // Disapprove
                                marginRight: "8px",
                              }}
                            ></strong>
                            Disapprove
                          </li>
                          <li>
                            <strong
                              style={{
                                display: "inline-block",
                                width: "16px",
                                height: "16px",
                                backgroundColor: "#FFFF00", // Pending
                                marginRight: "8px",
                                border: "1px solid #ccc",
                              }}
                            ></strong>
                            Pending
                          </li>
                          <li>
                            <strong
                              style={{
                                display: "inline-block",
                                width: "16px",
                                height: "16px",
                                backgroundColor: "lightblue", // Approved
                                marginRight: "8px",
                              }}
                            ></strong>
                            Approved
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveApplication;

